import { render, staticRenderFns } from "./EventManageSettings.vue?vue&type=template&id=2e2413e2"
import script from "./EventManageSettings.vue?vue&type=script&lang=js"
export * from "./EventManageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports